
import React from 'react';
import { Button } from '@/components/ui/button';

const HeroSection: React.FC = () => {
  return (
    <section className="bg-itmgmt-dark-blue text-white py-16 md:py-24">
      <div className="container-wide">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="heading-xl mb-6">
              IT Management Solutions for <span className="text-itmgmt-bright-blue">Small Business Growth</span>
            </h1>
            <p className="text-xl mb-8 text-gray-300">
              We help small businesses thrive with reliable IT support, proactive cybersecurity, and cost-effective tech management. 
              Whether you need fully managed services or co-managed IT help, our expert team reduces downtime, improves security, 
              and supports your team — both locally and remotely.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild className="button-primary">
                <a href="#contact">Book a Free Consultation</a>
              </Button>
              <Button asChild variant="outline" className="bg-transparent border-white text-white hover:bg-white hover:text-itmgmt-dark-blue">
                <a href="#services">Explore Our Services</a>
              </Button>
            </div>
          </div>
          <div className="hidden lg:block">
            <img 
              src="https://images.unsplash.com/photo-1605810230434-7631ac76ec81?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
              alt="IT Management Solutions Team" 
              className="rounded-lg shadow-lg"
              width="800"
              height="600"
              loading="eager"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
